import BaseService from "../../base/base_service";
import ICasinofiedAppLauncherProxyService from "./casinofied_app_launcher_proxy_service_interface";
import {
    ICasinofiedAppLauncherService, ILaunchAppData
} from "../../../../app-react/services/casinofied/app-launcher/casinofied-app-launcher.service.interface";
import {
    IChatSpecificParams, IControlCenterBaseSpecificParams,
    IControlCenterFullSpecificParams,
    SequentialCorrelationIdHandler
} from "@sparkware/uc-sdk-core";
import {
    ICasinofiedApplication
} from "../../../../app-react/services/casinofied/app-launcher/apps/casinofied-application.interface";

interface CasinofiedAppLauncherProxyServiceParams {
    casinofiedAppLauncher: () => ICasinofiedAppLauncherService;
}


export default class CasinofiedAppLauncherProxyService extends BaseService implements ICasinofiedAppLauncherProxyService {
    static CLASS = 'CasinofiedAppLauncherProxyService';

    private _params: CasinofiedAppLauncherProxyServiceParams;
    init(params: CasinofiedAppLauncherProxyServiceParams) {
        this._params = params;
    }

    get isThereRunningApps(): boolean {
        return this._params.casinofiedAppLauncher().isThereRunningApps;
    }

    getSequentialCorrelationIdHandler(bussinesCorrelationId: string): SequentialCorrelationIdHandler {
        return this._params.casinofiedAppLauncher().getSequentialCorrelationIdHandler(bussinesCorrelationId);
    }

    openCashoutWidget(openParams: ILaunchAppData): Promise<ICasinofiedApplication | null> {
        return this._params.casinofiedAppLauncher().openCashoutWidget(openParams);
    }

    openChat(params: ILaunchAppData<IChatSpecificParams>): Promise<ICasinofiedApplication | null> {
        return this._params.casinofiedAppLauncher().openChat(params);
    }

    openContactUs(params: ILaunchAppData): Promise<ICasinofiedApplication | null> {
        return this._params.casinofiedAppLauncher().openContactUs(params);
    }

    openControlCenterFull(params: ILaunchAppData<IControlCenterFullSpecificParams>): Promise<ICasinofiedApplication | null> {
        return this._params.casinofiedAppLauncher().openControlCenterFull(params);
    }

    openControlCenterMini(params: ILaunchAppData<IControlCenterBaseSpecificParams>): Promise<ICasinofiedApplication | null> {
        return this._params.casinofiedAppLauncher().openControlCenterMini(params);
    }

    openDepositWidget(openParams: ILaunchAppData): Promise<ICasinofiedApplication | null> {
        return this._params.casinofiedAppLauncher().openDepositWidget(openParams);
    }

    openFreeToPlayBonusGames(openParams: ILaunchAppData): Promise<ICasinofiedApplication | null> {
        return this._params.casinofiedAppLauncher().openFreeToPlayBonusGames(openParams);
    }

    openHelpCenter(params: ILaunchAppData): Promise<ICasinofiedApplication | null> {
        return this._params.casinofiedAppLauncher().openHelpCenter(params);
    }

    openTransactionHistoryWidget(openParams: ILaunchAppData): Promise<ICasinofiedApplication | null> {
        return this._params.casinofiedAppLauncher().openTransactionHistoryWidget(openParams);
    }
}